import { useState, useEffect } from 'react';
import { apiUtils } from './useApi';
import { API_ENDPOINTS } from '../services/apiEndpoints';
import { UserProfile } from '../utils/userUtils';

interface ProfileResponse {
  success: boolean;
  user: UserProfile;
}

export const useProfile = () => {
  const [profileData, setProfileData] = useState<ProfileResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const response = await apiUtils.get<ProfileResponse>(
        API_ENDPOINTS.auth.profile
      );

      console.log("Profile Response ::", response.data);
      setProfileData(response.data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch profile');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return { profileData, loading, error, refetch: fetchProfile };
};
